import { BACKEND_URL } from '../api/baseQuery';
import { getStorageToken, handleUserResponse } from './auth-client';

const apiCall = (endpoint: string, processResponseFn: any, body: any) => {
  const headers = {
    'content-type': 'application/json',
    'Auth': '',
  };

  let token = getStorageToken();
  if (token == null) {
    headers.Auth = 'Noauth';
  } else {
    headers.Auth = token;
  }
  const config = {
    method: body ? 'POST' : 'GET',
    headers: {
      ...headers,
    },
    body: body ? JSON.stringify(body) : undefined,
  };
  return fetch(`${BACKEND_URL}/${endpoint}`, config)
    .then((response) => {
      if (response.status !== 200 && response.status !== 204) {
        return processResponseFn(response)
          .then((resp: any) => Promise.reject(resp));
      }
      return processResponseFn(response);
    });
};

export const client = (endpoint: string, body: any = null) => {
  let fn = async (response: Response): Promise<string> => {
    return await response.text();
  };
  return apiCall(endpoint, fn, body);
};

export const clientJson = (endpoint: string, body: any = null) => {
  let fn = async (response: Response): Promise<any> => {
    try {
      const data = await response.json();
      const token = response.headers.get('Auth');
      if (token) {
        handleUserResponse(token);
      }
      return data;
    } catch (e) {
      return new Promise(resolve => resolve(null));
    }
  };
  return apiCall(endpoint, fn, body);
};


